import {useRouter} from 'next/router';
import {NextSeo} from 'next-seo';
import Error from 'next/error';

import {BlogPageQuery, BlogPagesQuery} from 'src/views/Blog/queries';
import {prepareInitialProps} from 'src/core/initialPropsSSP';
import {MINUTE} from 'src/core/utils';
import {Content} from 'src/views/Blog/Page';
import {PageNext} from 'src/componentsNext/PageNext';

import {initializeApollo} from '../../apollo/client';

import {App} from 'src/components/App';
import Page from 'src/components/Page';
import Loader from 'src/components/Loader';

function BlogPage(props) {
  const router = useRouter();
  return (
    <App {...props}>
      <PageNext isOldPage>
        {router.isFallback ? (
          <>
            <NextSeo noindex nofollow />
            <Loader />
          </>
        ) : props.page ? (
          <Content blogPage={props.page} />
        ) : (
          <>
            <NextSeo noindex nofollow />
            <Error statusCode={404} />
          </>
        )}
        {/* <BottomBanner /> */}
      </PageNext>
    </App>
  );
}

// This function gets called at build time
export async function getStaticPaths() {
  const apolloClient = initializeApollo();
  const {data} = await apolloClient.query({
    query: BlogPagesQuery,
    variables: {perPage: 24}
  });
  const paths = [];
  data.blogPages.edges.map(({node: page}) => {
    paths.push({
      params: {
        slug: page.slug
      }
    });
  });
  return {
    paths,
    fallback: true
  };
}

export async function getStaticProps(ctx) {
  const pageProps = await prepareInitialProps(ctx, {loadReviews: false});
  const apolloClient = initializeApollo();
  const {data: BlogPageData} = await apolloClient.query({
    query: BlogPageQuery,
    variables: {slug: ctx.params.slug}
  });
  return {
    revalidate: MINUTE,
    props: {
      ...pageProps,
      page: BlogPageData.blogPage
    }
  };
}

export default BlogPage;
